<template>
  <div>
    <header
      class="flex justify-center md:justify-between h-header md:h-28 top-0 left-0 w-full md:absolute"
    >
      <div class="bg-white flex-1 flex-grow-0">
        <a
          href="/"
          class="w-88 md:w-120 flex justify-center items-center h-full px-8"
        >
          <Logo />
        </a>
      </div>
    </header>
    <section class="pt-8 pb-24 md:pt-32 md:pb-32">
      <div class="container">
        <div class="m-auto max-w-400">
          <h1 class="lg:block font-normal text-4xl mb-8 md:mb-20">
            Cookie Policy
          </h1>
          <p class="mb-10">
            Le informazioni di cui alla presente cookie policy (la "<strong
              >Cookie Policy</strong
            >") sono rese dal Titolare (come di seguito definito) ad
            integrazione di quanto all'informativa sul trattamento dei dati
            personali, resa sempre disponibile all'interno del presente sito web
            (il "<strong>Sito</strong>"), nonchè accessibile al seguente link:
            <a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="/privacy"
              >Informativa relativa al sito web</a
            >. La presente Cookie Policy descrive i diversi tipi di cookie che
            possono essere installati mediante il Sito, le relative finalità, la
            durata della conservazione dei dati personali così raccolti, nonché
            le modalità per controllare l'installazione di tali cookie.
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            Titolare Del Trattamento e Responsabile Della Protezione Dei Dati
          </p>
          <p class="mb-4">
            <strong> Il Titolare del Trattamento</strong> è UniCredit RE
            Services S.p.A. con sede legale in via Livio Cambi, 5, 20151 Milano
            MI.
          </p>
          <p class="mb-8">
            Il <strong>Responsabile della protezione dei dati</strong> può
            essere contattato presso <strong>UniCredit S.p.A.</strong>, Data
            Protection Office, Piazza Gae Aulenti n.3, Tower A, 20154 Milano,
            E-mail:
            <a target="_blank" href="mailto:Group.DPO@unicredit.eu"
              >Group.DPO@unicredit.eu</a
            >, PEC:
            <a target="_blank" href="mailto:Group.DPO@pec.unicredit.eu"
              >Group.DPO@pec.unicredit.eu</a
            >.
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            I Cookie Utilizzati Da Questo Sito
          </p>
          <p class="mb-4">
            I cookie sono stringhe di testo di piccole dimensioni che i siti Web
            visitati dall'Utente inviano al Browser del suo Device (PC,
            Notebook, Smartphone, Tablet, ecc..), dove vengono memorizzati per
            essere poi ritrasmessi agli stessi siti alla successiva visita del
            medesimo Utente.
          </p>
          <p class="mb-8">
            UniCredit RE Services S.p.A. informa che questo sito Web utilizza,
            anche in combinazione tra di loro, le tipologie di cookie di seguito
            descritte, classificate sulla base dei Provvedimenti e delle
            Indicazioni dell'Autorità Garante per la protezione dei Dati
            Personali, del Comitato Europeo per la Protezione dei Dati (EDPB),
            del Regolamento (UE) 2016/679 del Parlamento Europeo e del Consiglio
            del 27 aprile 2016 (c.d. GDPR) e del Decreto Legislativo 10 agosto
            2018, n. 101.
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">cookie tecnici</p>
          <p class="mb-4">
            Sono i cookie che risultano indispensabili per permettere la
            <strong
              >trasmissione di una comunicazione sulla rete di comunicazione
              elettronica e la fruizione dei servizi richiesti dall'Utente
              stesso</strong
            >
            (c.d. "<strong>cookie di navigazione o di sessione</strong>") come
            ad esempio la gestione delle manifestazioni di interesse ai servizi
            di mediazione immobiliare forniti nonché l'autenticazione per
            l'accesso all'Area Riservata, per le quali tali cookie consentono di
            effettuare e mantenere l'identificazione dell'utente nell'ambito
            della sessione. Senza il ricorso a tali cookie, la navigazione nel
            sito Web ed alcune operazioni richieste dall'Utente non potrebbero
            essere compiute o sarebbero meno sicure.
          </p>
          <p class="mb-8">
            Tali Cookie Tecnici sono installati
            <strong>direttamente da UniCredit RE Services</strong> e, poiché non
            vengono utilizzati per scopi ulteriori rispetto a quelli
            strettamente necessari per effettuare la trasmissione di una
            comunicazione su una rete di comunicazione elettronica oppure per
            fornire ed erogare un Servizio esplicitamente richiesto dall'Utente,
            la loro memorizzazione nel Device
            <strong
              >non richiede il preventivo consenso dell'Utente che accede al
              sito Web di UniCredit RE Services.</strong
            >
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">cookie analytics</p>
          <p class="mb-4">
            Sono i cookie utilizzati per la produzione di statistiche in forma
            aggregata e rigorosamente anonima a fini interni di ricerca sul
            numero degli utenti e su come questi visitano il Sito.
          </p>
          <p class="mb-4">
            UniCredit RE Services utilizza per i Cookie Analytics un
            <strong>meccanismo di cifratura</strong> irreversibile dell'intero
            <strong>Indirizzo IP </strong>(Indirizzo assegnato al Device
            dell'Utente e necessario alla navigazione nella Rete Internet) e di
            ulteriori altri dati, allo scopo di
            <strong>deidentificare</strong> l'Utente visitatore. In particolare,
            l'indirizzo IP di ciascun utente viene sostituito con un codice
            alfanumerico che non ha alcun collegamento con l'indirizzo IP ed
            altre informazioni riferibili all'utente, e che ha come unico scopo
            quello di distinguere un utente dall'altro.
          </p>
          <p class="mb-8">
            L'installazione di cookie analytics è finalizzata unicamente
            <strong
              >a migliorare il servizio reso dal Titolare a tutti gli utenti,
              nonchè all'ottimizzazione e al miglioramento del Sito.</strong
            >
          </p>
          <p class="mb-8">
            In conformità alla normativa applicabile per questi tipi di Cookie
            la loro memorizzazione nel Device
            <strong
              >non richiede il preventivo consenso dell'Utente che accede al
              sito Web di UniCredit RE Services.</strong
            >
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            cookie di profilazione
          </p>
          <p class="mb-8">
            Sono i cookie utilizzati per
            <strong>
              inviare messaggi pubblicitari in linea con le preferenze espresse
              dall’utente nell’ambito della navigazione online </strong
            >. Tali cookie possono essere memorizzati nel device dell’utente
            direttamente dal Titolare o da soggetti diversi (di seguito, le
            "Terze Parti").
          </p>
          <p class="mb-8">
            Ai fini dell’installazione dei cookie di profilazione è necessario
            il previo consenso dell’utente.
          </p>
          <p class="mb-8">
            L’utente è libero, in qualsiasi momento,
            <strong
              >di gestire le proprie preferenze in relazione ai cookie di
              profilazione</strong
            >
            accedendo al link "<a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="/fai-le-tue-scelte-cookie"
              >Le tue scelte sui Cookie</a
            >", reso sempre disponibile anche da ciascuna pagina del Sito.
          </p>
          <p class="mb-8">
            Attraverso questo Sito vengono installati anche
            <strong>cookie gestiti da Terze Parti</strong>, che agiscono in
            qualità di autonomi titolari del trattamento.
          </p>
          <p class="mb-8">
            Cliccando su "<a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="/fai-le-tue-scelte-cookie"
              >Le tue scelte sui Cookie</a
            >", l’utente potrà accedere alle cookie policy delle Terze Parti che
            installano cookie di profilazione mediante questo Sito e, quindi,
            gestire detti cookie in forma granulare.
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            gestione e cancellazione dei cookie mediante configurazione del
            browser utilizzato
          </p>
          <p class="mb-4">
            UniCredit RE Services S.p.A. informa che, in aggiunta a quanto sopra
            esposto, l'Utente che accede al sito web potrà manifestare o
            modificare le
            <strong
              >proprie scelte ed opzioni sui cookie anche attraverso le
              ulteriori impostazioni del Browser utilizzato nel proprio
              device.</strong
            >
          </p>
          <p class="mb-4">
            L'Utente potrà in ogni momento
            <strong
              >cancellare o disabilitare direttamente qualunque Cookie</strong
            >
            attraverso le previste funzioni e le impostazioni del Browser
            utilizzato nel suo PC, Notebook, Smartphone o Tablet.
          </p>
          <p class="mb-4">
            Si pone in evidenza che le opzioni effettuate attraverso le
            impostazioni del Browser
            <strong
              >avranno effetto solo dal primo collegamento dell'Utente al sito
              web di UniCredit RE Services</strong
            >
            effettuato successivamente alla modifica di tali impostazioni, in
            relazione alle scelte operate direttamente in tale sito Web.
          </p>
          <p class="mb-4">
            Rimandiamo alle informazioni ed alle procedure operative da eseguire
            per configurare le impostazioni, fornite dal Fornitore del Browser
            utilizzato dall'Utente.
          </p>
          <p class="mb-4">
            <strong>Firefox:</strong
            ><a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop"
              >https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop</a
            >
          </p>
          <p class="mb-4">
            <strong>Internet Explorer:</strong>
            <a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
              >https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d</a
            >
          </p>
          <p class="mb-4">
            <strong>Safari:</strong
            ><a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="https://support.apple.com/it-it/HT201265"
              >https://support.apple.com/it-it/HT201265</a
            >
          </p>
          <p class="mb-4">
            <strong>Chrome:</strong
            ><a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="https://support.google.com/chrome/answer/95647"
              >https://support.google.com/chrome/answer/95647</a
            >
          </p>
          <p class="mb-8">
            <strong>Opera:</strong
            ><a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="https://help.opera.com/en/latest/web-preferences/#cookies"
              >https://help.opera.com/en/latest/web-preferences/#cookies</a
            >
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            revoca o modifica del consenso all'installazione dei cookie
          </p>
          <p class="mb-4">
            Il Titolare informa che l'utente del Sito potrà modificare la sua
            scelta in merito alla memorizzazione dei cookie in qualsiasi
            momento, <strong>accedendo alla sezione del Sito</strong
            ><a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="/fai-le-tue-scelte-cookie"
            >
              Le tue scelte sui Cookie.</a
            >
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            trasferimento dei dati verso paesi terzi
          </p>
          <p class="mb-8">
            UniCredit RE Services informa che i Dati Personali potranno essere
            trasferiti anche in paesi non appartenenti all'Unione Europea o allo
            Spazio Economico Europeo (cd. Paesi Terzi) solo se riconosciuti
            dalla Commissione Europea aventi un livello adeguato di protezione
            dei dati personali e che sia sempre assicurato l'esercizio dei
            diritti degli Interessati. Ulteriori informazioni possono essere
            richieste scrivendo a
            <a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="mailto:Group.DPO@unicredit.eu"
              >Group.DPO@unicredit.eu</a
            >
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            diritti degli interessati
          </p>
          <p class="mb-4">
            Il REGOLAMENTO (UE) 2016/679 del Parlamento Europeo e del Consiglio
            del 27 aprile 2016 (il "<strong>GDPR</strong>") attribuisce alle
            persone fisiche, ditte individuali e/o liberi professionisti
            ("<strong>Interessati</strong>") specifici diritti, tra i quali
            quello di conoscere quali sono i dati personali in possesso della
            Banca e come questi vengono utilizzati (<strong
              >Diritto di accesso</strong
            >), di ottenerne <strong>l'aggiornamento</strong>,
            <strong>la rettifica</strong> o, se vi è interesse,
            <strong>l'integrazione</strong>, nonché la
            <strong>cancellazione</strong>, la trasformazione in
            <strong>forma anonima</strong> o la <strong>limitazione</strong>.
          </p>
          <p class="mb-4">
            Gli utenti possono, in <strong>qualsiasi momento</strong>, revocare
            il consenso eventualmente prestato alla memorizzazione nel proprio
            device dei cookie ed all'eventuale trattamento dei dati personali
            conseguente all'utilizzo dei cookie, nei termini sopra riportati.
          </p>
          <p class="mb-4">
            UniCredit RE Services pone in evidenza che la revoca del consenso
            avrà effetto solo per il futuro.
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            PERIODO DI CONSERVAZIONE DEI DATI E DIRITTO ALLA CANCELLAZIONE (I.E.
            DIRITTO ALL'OBLIO)
          </p>
          <p class="mb-4">
            Il Titolare tratterà le informazioni raccolte per quanto
            strettamente necessario al perseguimento delle finalità
            predeterminate; i dati raccolti mediante
            <strong>cookie di profilazione</strong> di prima parte saranno
            trattati per un periodo massimo di 6 mesi.
          </p>
          <p class="mb-8">
            <strong>Al termine del predetto periodo di conservazione</strong>,
            le informazioni raccolte verranno cancellate o
            <strong
              >conservate in una forma che non consenta
              l'identificazione</strong
            >
            dell'utente (es. <strong>anonimizzazione irreversibile</strong>), a
            meno che il loro ulteriore trattamento sia necessario per uno o più
            dei seguenti scopi: I) risoluzione di
            <strong>precontenziosi e/o contenziosi</strong>
            avviati prima della scadenza del periodo di conservazione; II) per
            dare seguito ad indagini/ispezioni da parte di funzioni di controllo
            interno e/o autorità esterne avviati prima della scadenza del
            periodo di conservazione; III) per dare seguito a richieste della
            <strong>pubblica autorità italiana e/o estera</strong>
            pervenute/notificate al Titolare prima della scadenza del periodo di
            conservazione.
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            modalità di esercizio dei diritti
          </p>
          <p class="mb-4">
            Ciascun Interessato per esercitare i diritti di cui al precedente
            paragrafo potrà rivolgersi a:
          </p>
          <p class="mb-4 font bold">
            UniCredit RE Services S.p.A., Legal & Compliance, via Livio Cambi,
            5, 20151 Milano MI, fax +39 0297688500, indirizzo e-mail:
            privacy@unicreditreservices.it.
          </p>
          <p class="mb-4">
            Il termine per la risposta è un <strong>(1) mese</strong>,
            prorogabile di due <strong>(2) mesi</strong> in casi di particolare
            complessità; in questi casi, la Società fornisce almeno una
            comunicazione interlocutoria entro un <strong>(1) mese</strong>.
          </p>
          <p class="mb-4">
            L'esercizio dei diritti è, in linea di principio, gratuito;
            UniCredit RE Services si riserva il diritto di chiedere un
            contributo in caso di richieste manifestamente infondate o eccessive
            (anche ripetitive).
          </p>
          <p class="mb-8">
            UniCredit RE Services ha il diritto di chiedere informazioni
            necessarie a fini identificativi del richiedente.
          </p>
          <p class="mb-4 uppercase font-normal text-2xl">
            reclamo o segnalazione al garante per la protezione dei dati
            personali
          </p>
          <p class="mb-4">
            UniCredit RE Services La informa che Lei ha diritto di proporre
            reclamo ovvero effettuare una segnalazione al Garante per la
            Protezione dei Dati Personali oppure in alternativa presentare
            ricorso all'Autorità Giudiziaria. I contatti del Garante per la
            Protezione dei Dati Personali sono consultabili sul sito
            <a
              target="_blank"
              class="text-blue underline cursor-pointer"
              href="https://www.garanteprivacy.it/"
              >http://www.garanteprivacy.it.</a
            >
          </p>
          <p class="underline">
            L'esercizio dei diritti è, in linea di principio, gratuito; Avendo
            preso visione dell'Informativa Privacy relativa ai Cookie sopra
            riportata, Le chiediamo di manifestare liberamente la Sua volontà
            <strong
              >esprimendo o negando il consenso per la memorizzazione dei Cookie
              di Profilazione nel Suo Device secondo le modalità sopra
              descritte.</strong
            >
          </p>
        </div>
      </div>
    </section>
    <div class="bg-black text-white">
      <div class="container">
        <div class="flex flex-col items-center justify-center h-64">
          <p class="mb-12 text-root">
            © 2014 - 2023 UniCredit RE Services Tutti i diritti riservati -
            P.IVA n° 08583660967 -
            <a
              class="underline"
              :href="`${$config.baseURL}/informativacookies`"
              target="_blank"
              >Cookie Policy</a
            >
          </p>
          <Logo
            :type="$options.LogoTypes.White"
            :size="$options.LogoSizes.Small"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Static assets
import LogoSizes from '~/assets/js/logo/sizes'
import LogoTypes from '~/assets/js/logo/types'

// Components
import Logo from '~/components/Logo.vue'

export default {
  components: { Logo },

  LogoSizes,
  LogoTypes,

  layout: 'empty',

  head() {
    return {
      title: 'Cookie Policy',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Informativa per siti con cookies di profilazione del portale immobiliare UniCredit RE Services',
        },
      ],
    }
  },
}
</script>
